import { useMemo } from 'react';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { useLanguage } from '../../../../context/LanguageContext';
import { Store, Tpe } from '../../../../types/Store';
import StoreCard from './common/StoreCard';
import StoreTable from './common/StoreTable';

interface TpesProps {
    store: Store;
    isEditable?: boolean;
}

const formatDate = (dateString?: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('fr-FR');
};

const formatDateTime = (dateString?: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

function Tpes({ store }: TpesProps) {
    const { t } = useLanguage();
    const tpes = store.TPE || [];

    const columns = useMemo(() => [
        { label: t('pages.store.tpeNumber'), key: 'INTERNAL_NUMBER' },
        {
            label: t('pages.store.activationDate'),
            render: (tpe: Tpe) => formatDate(tpe.ACTIVATION_DATE),
        },
        { label: t('pages.store.connectionMode'), key: 'CONNECTION_MODE' },
        { label: t('pages.store.model'), key: 'NAME' },
        {
            label: t('pages.store.cancellationDate'),
            render: (tpe: Tpe) => formatDate(tpe.CANCELLATION_DATE),
        },
        {
            label: t('pages.store.lastTransactionDate'),
            render: (tpe: Tpe) => formatDateTime(tpe.LAST_TRANSACTION_DATE),
        },
    ], [t]);

    return (
        <StoreCard
            title={t('pages.store.tpe')}
            icon={<PointOfSaleIcon sx={{ color: '#556ee6' }} />}
            isEmpty={tpes.length === 0}
            emptyMessage={t('pages.store.noTpe')}
        >
            <StoreTable columns={columns} data={tpes} />
        </StoreCard>
    );
};

export default Tpes;

